import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_review",
  "use": "icon-map_review-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_review\">\n<g id=\"icon-map_review_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 15 10 C 13.371094 10.636719 11.664063 11.609375 9.976563 12.0625 C -2.347656 15.382813 8 -4 11 7 C 13.90625 6.484375 14.484375 6 15 3 C 12.367188 2.503906 9.761719 1 7 1.285156 C -5.722656 2.710938 6.566406 24.445313 15 10 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_review.svg
// module id = mh7R
// module chunks = 24